module.exports = __webpack_public_path__ + "img/lg_ring_r_0_null_1@2x.0a187e60.png";